const joinUsList = [{
        name: "福利待遇",
        title: "福利待遇",
        list: [{
                name: "商业保险",
                img: "/static/img/joinUs/1.png",
            },
            {
                name: "交通餐补",
                img: "/static/img/joinUs/2.png",
            },
            {
                name: "节日关怀",
                img: "/static/img/joinUs/3.png",
            },
            {
                name: "年度体检",
                img: "/static/img/joinUs/4.png",
            },
            {
                name: "互助小组",
                img: "/static/img/joinUs/5.png",
            },
            {
                name: "头脑风暴",
                img: "/static/img/joinUs/6.png",
            },
            {
                name: "带薪年假",
                img: "/static/img/joinUs/7.png",
            },
            {
                name: "出差补助",
                img: "/static/img/joinUs/8.png",
            },
        ],
    },
    {
        name: "社会招聘",
        title: "社会招聘",
        titleList: [
            { key: "name", val: "职位名称" },
            { key: "position", val: "工作岗位" },
            { key: "addr", val: "工作地点" },
        ],
        job: [{
                name: "计算机视觉算法工程师",
                position: "研发类",
                addr: "北京、天津、深圳",
                workShow: false,
                work: [{
                        name: "岗位职责",
                        data: [
                            "1、负责计算机视觉算法，如物体检测、分割、跟踪、识别等算法的研发；",
                            "2、参与虹膜人脸识别算法、工业视觉算法研发；",
                            "3、完成算法的工程化，如重构和封装；",
                            "4、负责算法在嵌入式系统上的实现；",
                            "5、负责算法模型的压缩和加速；",
                            "6、负责计算机视觉算法的前沿技术的研发工作。",
                        ],
                    },
                    {
                        name: "任职要求",
                        data: [
                            "1、机器学习、模式识别相关专业硕士及以上学历；",
                            "2、熟悉主流机器学习算法与原理；",
                            "3、优秀的C/C++编程能力，良好的代码风格，熟悉Matlab、Python、Linux；",
                            "4、良好的英语能力，能熟练阅读英文论文和专利；",
                            "5、良好的创新力与动手能力，责任心强，具有团队意识；",
                            "6、有图像处理系统研发经历者优先；",
                            "7、熟悉深度学习原理、精通Caffe、Tensorflow、MxNet等任一种深度学习开源框架者优先。",
                        ],
                    },
                ],
            },
            {
                name: "C++开发工程师",
                position: "研发类",
                addr: "北京、天津、深圳",
                workShow: false,
                work: [{
                        name: "岗位职责",
                        data: [
                            "1、维护已有的C++软件产品，参与新的软件的设计开发；",
                            "2、负责产品的技术支持和需求定制。",
                        ],
                    },
                    {
                        name: "任职要求",
                        data: [
                            "1、本科及以上学历，计算机相关专业；",
                            "2、熟悉C/C++，了解常用数据结构；",
                            "3、熟悉开发流程，了解面向对象设计，有相关开发经验；",
                            "4、有MySql/sqlServer开发经验；",
                            "5、具有良好的沟通能力、有较强的独立工作能力和解决问题的能力；",
                            "6、为人正直、诚信，积极上进，对工作认真负责，能承受较大工作压力。",
                        ],
                    },
                ],
            },
            {
                name: "Java开发工程师",
                position: "研发类",
                addr: "北京、天津、深圳",
                workShow: false,
                work: [{
                        name: "岗位职责",
                        data: [
                            "1、参与项目需求分析，进行系统框架和核心模块的详细设计，解决开发中出现的疑难问题；",
                            "2、根据业务需求进行系统模块的技术文档编写及设计；",
                            "3、独立完成软件产品的设计、开发及测试工作；",
                            "4、参与方案讨论、技术研究及参与新产品的技术预研。",
                        ],
                    },
                    {
                        name: "任职要求",
                        data: [
                            "1、本科及以上学历，计算机专业，有项目开发工作经验优先；",
                            "2、良好的代码风格，熟悉java语言开发；",
                            "3、熟悉spring boot框架，熟悉mysql数据库；",
                            "4、对编程保持热情，能够自我约束，持续进步。",
                        ],
                    },
                ],
            },
            {
                name: "FPGA硬件工程师",
                position: "研发类",
                addr: "北京、天津、深圳",
                workShow: false,
                work: [{
                        name: "岗位职责",
                        data: [
                            "1、负责产品硬件、固件和嵌入式软件的开发；",
                            "2、负责FPGA、ARM平台开发和调试工作；",
                            "3、配合其他部门完成产品的调试和测试，完成上级交待的其他任务。",
                        ],
                    },
                    {
                        name: "任职要求",
                        data: [
                            "1、计算机、自动化、电子或相关专业本科及以上学历；",
                            "2、精通C/C++语言，熟悉Linux或Windows下开发和调试；",
                            "3、有电路基础和分析能力，可独立完成相关的原理图设计和电路调试；",
                            "4、掌握FPGA逻辑开发、有高速接口设计者优先；",
                            "5、工作认真负责，态度积极。",
                        ],
                    },
                ],
            },
            {
                name: "电子设计工程师",
                position: "研发类",
                addr: "北京、天津、深圳",
                workShow: false,
                work: [{
                        name: "岗位职责",
                        data: [
                            "1、负责产品开发阶段的电子分系统设计和样机的电子分系统验证工作；",
                            "2、负责产品问题中电子相关问题的定位和解决；",
                            "3、负责不断积累电子信号控制或处理的新技术，并不断实现标准模块的积累；",
                            "4、负责电子测试验证工具或平台的设计和实施，主要包括功能、性能和可靠性。",
                        ],
                    },
                    {
                        name: "任职要求",
                        data: [
                            "1、具备扎实的模拟、数字电路基础和控制系统理论基础知识；",
                            "2、熟练使用万用表、示波器、电烙铁等调试工具，动手能力强；",
                            "3、熟悉嵌入式系统的电子设计和调试；",
                            "4、熟练使用cadence/AD等EDA设计原理图和PCB；",
                            "5、电子/计算机/自动化等相关专业本科及以上学历，Layout经验丰富者优先。",
                        ],
                    },
                ],
            },
            {
                name: "系统测试工程师",
                position: "研发类",
                addr: "北京、天津、深圳",
                workShow: false,
                work: [{
                        name: "岗位职责",
                        data: [
                            "1、参与到产品项目的整个流程之中，根据需求评审结果设计并执行测试和验证用例；",
                            "2、负责公司产品系统测试、自动化测试，包含系统功能测试、性能测试和稳定性测试；",
                            "3、负责公司产品系统组装、测试和交付流程的质量把控与文档记录，保证产品的顺利交付；",
                            "4、撰写测试报告，及时发现并汇报问题，跟踪全程并评估风险，保证项目质量；",
                            "5、推动并监控整个项目测试流程和交付流程的实施，推动问题的解决。",
                        ],
                    },
                    {
                        name: "任职要求",
                        data: [
                            "1、计算机或自动化相关专业；",
                            "2、熟悉电子行业的制造工艺及生产测试流程，会分析电路原理；",
                            "3、至少熟悉一种脚本语言，如：python、shell、C/C++等，能开发相应测试需求的工具；",
                            "4、熟练使用Office办公软件，有良好的报告编写能力；",
                            "5、具备较强的沟通、协调能力，具备较强的责任意识。",
                        ],
                    },
                ],
            },
            {
                name: "产品经理",
                position: "产品类",
                addr: "北京、天津、深圳",
                workShow: false,
                work: [{
                        name: "岗位职责",
                        data: [
                            "1、挖掘用户需求，优化用户体验，创造产品价值；",
                            "2、产品的市场调研、竞品分析和方向确认、客户需求沟通对接，生成产品功能定义，并推进与落实；",
                            "3、跟进产品和项目开发的各个环节，把控整体进展和风险；",
                            "4、协调组织项目、研发等资源，达成产品目标。",
                        ],
                    },
                    {
                        name: "任职要求",
                        data: [
                            "1、本科及以上学历，计算机相关专业；",
                            "2、热衷科技类产品，善于钻研及思考；",
                            "3、敏锐的市场洞察能力，严密的逻辑分析能力；",
                            "4、良好的沟通协作能力及一定的技术理解能力；",
                            "5、性格积极，思维灵活，结果导向。",
                        ],
                    },
                ],
            },
            {
                name: "生产技术员",
                position: "生产类",
                addr: "北京、天津、深圳",
                workShow: false,
                work: [{
                        name: "岗位职责",
                        data: [
                            "1、负责成像模组全流程的组装、生产和测试；",
                            "2、负责成像模组样品的测试验证，异常模组维修；",
                            "3、负责生产车间以及实验室设备的日常维护；",
                            "4、相关产品文档的撰写。",
                        ],
                    },
                    {
                        name: "任职要求",
                        data: [
                            "1、男女不限，学历高中/中专以上；",
                            "2、具有一年以上摄像头模组工厂生产线工作经验；",
                            "3、熟悉摄像头模组生产工艺流程，熟练操作模组生产制作的各种常用设备；",
                            "4、具有良好的沟通能力、团队协助能力；",
                            "5、工作积极主动，细致耐心，责任心强。",
                        ],
                    },
                ],
            },
            {
                name: "市场发展经理",
                position: "市场类",
                addr: "北京、天津、深圳",
                workShow: false,
                work: [{
                        name: "岗位职责",
                        data: [
                            "1、研究政府支持政策体系，制定政策申报计划，及时获悉政府的相关政策指令、申报信息，分析对公司发展的相关政策、计划和趋势走向等，并做合理部署与应对；",
                            "2、开展政府项目、荣誉、资质等申报、推进、兑现工作，独立完成项目可研报告及申报材料的编写等；",
                            "3、建立各级政府良好关系，协助推进政府业务拓展、渠道搭建、业务落地工作；",
                            "4、负责完成领导交办的其他工作。",
                        ],
                    },
                    {
                        name: "任职要求",
                        data: [
                            "1、计算机、光学、电子、人工智能等相关专业毕业或相关从业背景；",
                            "2、工作积极主动、计划性强、逻辑性和条理性较好；",
                            "3、具备一定文字写作功底，具备研究性思维，市场敏锐度较高；",
                            "4、学习能力和沟通表达能力强、团队合作能力突出、善于发现问题解决问题。",
                        ],
                    },
                ],
            },
            {
                name: "销售经理",
                position: "销售类",
                addr: "北京、天津、深圳",
                workShow: false,
                work: [{
                        name: "岗位职责",
                        data: [
                            "1、负责安防及生物特征识别产品的销售工作；",
                            "2、负责行业市场拓展、渠道管理、新客户开发，及相关信息搜集、分析；",
                            "3、负责跟踪行业内大型项目的建设跟进；",
                            "4、与客户进行商务沟通，签订合同，回收款项，按销售计划完成公司销售任务指标；",
                            "5、协调售前与售后技术支持资源，为客户提供良好的服务。",
                        ],
                    },
                    {
                        name: "任职要求",
                        data: [
                            "1、计算机背景、市场营销或相关专业专科及以上学历；",
                            "2、具备生物特征识别或安防产品销售工作经验，基本了解安防行业市场格局；",
                            "3、对销售工作有强烈的兴趣，勇于接受挑战，工作态度积极乐观；",
                            "4、具有出色的沟通表达能力，思维敏捷、善于应变，脚踏实地肯吃苦；",
                            "5、有较强的挖掘、跟踪市场信息的能力，良好的客户关系管理能力；",
                            "6、销售能力突出者，可放宽从业要求；",
                            "7、有千万级人工智能智慧门禁识别产品大项目经验优先。",
                        ],
                    },
                ],
            },
        ],
    },
    {
        name: "校园招聘",
        title: "校园招聘",
        titleList: [
            { key: "name", val: "职位名称" },
            { key: "position", val: "工作岗位" },
            { key: "addr", val: "工作地点" },
        ],
        job: [{
                name: "计算机视觉算法工程师",
                position: "研发类",
                addr: "北京、天津、深圳",
                workShow: false,
                work: [{
                        name: "岗位职责",
                        data: [
                            "1、负责计算机视觉算法，如物体检测、分割、跟踪、识别等算法的研发；",
                            "2、参与虹膜人脸识别算法、工业视觉算法研发；",
                            "3、完成算法的工程化，如重构和封装；",
                            "4、负责算法在嵌入式系统上的实现；",
                            "5、负责算法模型的压缩和加速；",
                            "6、负责计算机视觉算法的前沿技术的研发工作。",
                        ],
                    },
                    {
                        name: "任职要求",
                        data: [
                            "1、机器学习、模式识别相关专业硕士及以上学历；",
                            "2、熟悉主流机器学习算法与原理；",
                            "3、优秀的C/C++编程能力，良好的代码风格，熟悉Matlab、Python、Linux；",
                            "4、良好的英语能力，能熟练阅读英文论文和专利；",
                            "5、良好的创新力与动手能力，责任心强，具有团队意识；",
                            "6、有图像处理系统研发经历者优先；",
                            "7、熟悉深度学习原理、精通Caffe、Tensorflow、MxNet等任一种深度学习开源框架者优先。",
                        ],
                    },
                ],
            },
            {
                name: "C++开发工程师",
                position: "研发类",
                addr: "北京、天津、深圳",
                workShow: false,
                work: [{
                        name: "岗位职责",
                        data: [
                            "1、维护已有的C++软件产品，参与新的软件的设计开发；",
                            "2、负责产品的技术支持和需求定制。",
                        ],
                    },
                    {
                        name: "任职要求",
                        data: [
                            "1、本科及以上学历，计算机相关专业；",
                            "2、熟悉C/C++，了解常用数据结构；",
                            "3、熟悉开发流程，了解面向对象设计，有相关开发经验；",
                            "4、有MySql/sqlServer开发经验；",
                            "5、具有良好的沟通能力、有较强的独立工作能力和解决问题的能力；",
                            "6、为人正直、诚信，积极上进，对工作认真负责，能承受较大工作压力。",
                        ],
                    },
                ],
            },
            {
                name: "Java开发工程师",
                position: "研发类",
                addr: "北京、天津、深圳",
                workShow: false,
                work: [{
                        name: "岗位职责",
                        data: [
                            "1、参与项目需求分析，进行系统框架和核心模块的详细设计，解决开发中出现的疑难问题；",
                            "2、根据业务需求进行系统模块的技术文档编写及设计；",
                            "3、独立完成软件产品的设计、开发及测试工作；",
                            "4、参与方案讨论、技术研究及参与新产品的技术预研。",
                        ],
                    },
                    {
                        name: "任职要求",
                        data: [
                            "1、本科及以上学历，计算机专业，有项目开发工作经验优先；",
                            "2、良好的代码风格，熟悉java语言开发；",
                            "3、熟悉spring boot框架，熟悉mysql数据库；",
                            "4、对编程保持热情，能够自我约束，持续进步。",
                        ],
                    },
                ],
            },
            {
                name: "FPGA硬件工程师",
                position: "研发类",
                addr: "北京、天津、深圳",
                workShow: false,
                work: [{
                        name: "岗位职责",
                        data: [
                            "1、负责产品硬件、固件和嵌入式软件的开发；",
                            "2、负责FPGA、ARM平台开发和调试工作；",
                            "3、配合其他部门完成产品的调试和测试，完成上级交待的其他任务。",
                        ],
                    },
                    {
                        name: "任职要求",
                        data: [
                            "1、计算机、自动化、电子或相关专业本科及以上学历；",
                            "2、精通C/C++语言，熟悉Linux或Windows下开发和调试；",
                            "3、有电路基础和分析能力，可独立完成相关的原理图设计和电路调试；",
                            "4、掌握FPGA逻辑开发、有高速接口设计者优先；",
                            "5、工作认真负责，态度积极。",
                        ],
                    },
                ],
            },
            {
                name: "系统测试工程师",
                position: "研发类",
                addr: "北京、天津、深圳",
                workShow: false,
                work: [{
                        name: "岗位职责",
                        data: [
                            "1、参与到产品项目的整个流程之中，根据需求评审结果设计并执行测试和验证用例；",
                            "2、负责公司产品系统测试、自动化测试，包含系统功能测试、性能测试和稳定性测试；",
                            "3、负责公司产品系统组装、测试和交付流程的质量把控与文档记录，保证产品的顺利交付；",
                            "4、撰写测试报告，及时发现并汇报问题，跟踪全程并评估风险，保证项目质量；",
                            "5、推动并监控整个项目测试流程和交付流程的实施，推动问题的解决。",
                        ],
                    },
                    {
                        name: "任职要求",
                        data: [
                            "1、计算机或自动化相关专业；",
                            "2、熟悉电子行业的制造工艺及生产测试流程，会分析电路原理；",
                            "3、至少熟悉一种脚本语言，如：python、shell、C/C++等，能开发相应测试需求的工具；",
                            "4、熟练使用Office办公软件，有良好的报告编写能力；",
                            "5、具备较强的沟通、协调能力，具备较强的责任意识。",
                        ],
                    },
                ],
            },
            {
                name: "产品经理",
                position: "产品类",
                addr: "北京、天津、深圳",
                workShow: false,
                work: [{
                        name: "岗位职责",
                        data: [
                            "1、挖掘用户需求，优化用户体验，创造产品价值；",
                            "2、产品的市场调研、竞品分析和方向确认、客户需求沟通对接，生成产品功能定义，并推进与落实；",
                            "3、跟进产品和项目开发的各个环节，把控整体进展和风险；",
                            "4、协调组织项目、研发等资源，达成产品目标。",
                        ],
                    },
                    {
                        name: "任职要求",
                        data: [
                            "1、本科及以上学历，计算机相关专业；",
                            "2、热衷科技类产品，善于钻研及思考；",
                            "3、敏锐的市场洞察能力，严密的逻辑分析能力；",
                            "4、良好的沟通协作能力及一定的技术理解能力；",
                            "5、性格积极，思维灵活，结果导向。",
                        ],
                    },
                ],
            },
        ],
    },
    {
        name: "办公环境",
        title: "办公环境",
        data: {
            tj: [
                "/static/img/joinUs/environment/tj1.jpg",
                "/static/img/joinUs/environment/tj2.jpg",
                "/static/img/joinUs/environment/tj4.jpg",
                "/static/img/joinUs/environment/tj5.jpg",
            ],
            bj: [
                "/static/img/joinUs/environment/bj1.jpg",
                "/static/img/joinUs/environment/bj2.jpg",
                "/static/img/joinUs/environment/bj3.jpg",
                "/static/img/joinUs/environment/bj4.jpg",
            ],
            sz: [
                "/static/img/joinUs/environment/sz1.jpg",
                "/static/img/joinUs/environment/sz2.jpg",
                "/static/img/joinUs/environment/sz3.jpg",
                "/static/img/joinUs/environment/sz4.jpg",
            ]
        },
    },
];

// 给每一项添加唯一id
const addId = () => {
    for (let i = 0; i < joinUsList.length; i++) {
        joinUsList[i].id = i + 1;
    }
};
addId();

export default joinUsList;